import {Action} from '@ngrx/store';

export enum Page {
    loader = '[PAGE] loader'
}


export class Loader implements Action {
    readonly type = Page.loader;
    constructor(public payload) {}
}

export type Actions = Loader;
